import installLegacyPublicRouteCompatibility from './legacyPublicRouteCompatibility'
import registerUserRouteRefreshGuard from './userRouteRefreshGuard'
import registerPersonalSettingsRoutes from './personalSettingsRoutes'
import registerSecuritySettingsRoutes from './securitySettingsRoutes'
import registerPublicRouteReferenceRoutes from './publicRouteReferenceRoutes'

const TheContainer = () => import('@/containers/TheContainer')
const PlatformContractManagement = () => import('@/views/platform/PlatformContractManagement')
const ProviderRoleManagement = () => import('@/views/platform/ProviderRoleManagement')
const PlatformNotices = () => import('@/views/platform/PlatformNotices')
const PlatformBilling = () => import('@/views/platform/PlatformBilling')
const PlatformReceivables = () =>
  import('@/views/platform/PlatformReceivables')
const NationalHolidayMaster = () =>
  import('@/views/platform/NationalHolidayMaster')
const AccountInvitation = () => import('@/views/pages/AccountInvitation')

export default function registerPlatformAccessRoutes (router) {
  // 既存の汎用数値`:id`より先にUUID専用ルートを登録する。
  // この関数はmain.jsで最初に呼ばれる動的ルート登録処理なので、
  // 後続のProvider/Tenant/通知ルートを失わずmatcherを先頭拡張できる。
  registerPublicRouteReferenceRoutes(router)

  // 動的に追加する公開招待ルートを、F5・メール直リンク時も未ログインで表示する。
  installLegacyPublicRouteCompatibility(router)
  registerUserRouteRefreshGuard(router)
  registerPersonalSettingsRoutes(router)
  registerSecuritySettingsRoutes(router)
  router.addRoutes([
    {
      path: '/account-invitation',
      name: '契約企業管理者招待',
      component: AccountInvitation,
      meta: { public: true }
    },
    {
      path: '/platform',
      component: TheContainer,
      children: [
        {
          path: 'access-management',
          name: '契約企業一覧',
          component: PlatformContractManagement,
          meta: { requiresAuth: true, platformSuperAdmin: true }
        },
        {
          path: 'provider-role-management',
          name: '運営権限管理',
          component: ProviderRoleManagement,
          meta: { requiresAuth: true, platformSuperAdmin: true }
        },
        {
          // 全社のダッシュボードに出るお知らせ。**書けるのは運営だけ。**
          path: 'notices',
          name: 'お知らせ配信',
          component: PlatformNotices,
          meta: { requiresAuth: true, platformSuperAdmin: true }
        },
        {
          /*
           * 全社共通の祝日マスタ。**触れるのは運営だけ。**
           *
           * ここが埋まっていれば契約企業は祝日を入力しなくてよい。
           * 逆に、切れた翌日から全社の祝日が平日になる——
           * 勤務表の色も、法定休日の集計も、月末予測も、
           * 誰も気づかないままずれる。
           */
          path: 'national-holidays',
          name: '祝日マスタ',
          component: NationalHolidayMaster,
          meta: { requiresAuth: true, platformSuperAdmin: true }
        }
        ,{
          /*
           * 月次の請求。**発行ボタンを押す場所。**
           *
           * 一覧が無いと、発行の口を作っても押す画面が無い。
           * 「作ったのに出していない」を繰り返さない。
           */
          path: 'billing',
          name: '請求管理',
          component: PlatformBilling,
          meta: { requiresAuth: true, platformSuperAdmin: true }
        }
        ,{
          /*
           * 入金・売掛管理（会社 × 月の未収）。
           *
           * **請求管理の中に埋めない。**その月だけを見る画面と、
           * 会社ごとに月をまたいで見る画面は仕事が違う。
           * 中のタブにすると「場所が分からない」がまた起きる。
           */
          path: 'receivables',
          name: '入金・売掛管理',
          component: PlatformReceivables,
          meta: { requiresAuth: true, platformSuperAdmin: true }
        }
      ]
    }
  ])
}
